<template>
  <b-container fluid="lg">
    <b-row>
      <b-col sm="12" md="4" lg="3">
        <Title />
        <DrugSelect :selected-model="selectedModel" @clear-patient="update" />
        <b-card v-if="selectedModel" class="my-2 shadow rounded">
          <PatientInput :patient-data="patientData" />
          <TargetInput :drug="selectedDrug" :target-data="targetData" />
          <PathologyInput :drug="selectedDrug" :pathology-data="pathologyData" />
          <CreatinineInput :model="selectedModel" @switch-tab="switchTab" />
          <DoseInput :model="selectedModel" @switch-tab="switchTab" />
          <MeasuredInput @switch-tab="switchTab" />
          <DeliveryInput :delivery-data="deliveryData" />
        </b-card>
      </b-col>
      <b-col sm="12" md="8" lg="9">
        <PatientSummary @update-saved-list="update" @switch-tab="switchTab" />
        <TabPanels ref="results" :active-tab="activeTab" :update="updatePatient" />
      </b-col>
    </b-row>
    <b-row>
      <FooterComponent />
    </b-row>
  </b-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import Title from '@/components/Title.vue';
import FooterComponent from '@/components/Footer.vue';
import TabPanels from '@/components/display/TabPanels.vue';
import PatientSummary from '@/components/display/PatientSummary.vue';
import DrugSelect from '@/components/inputs/DrugSelect.vue';
import MeasuredInput from '@/components/inputs/MeasuredInput.vue';
import DeliveryInput from '@/components/inputs/DeliveryInput.vue';
import DoseInput from '@/components/inputs/DoseInput.vue';
import PatientInput from '@/components/inputs/PatientInput.vue';
import CreatinineInput from '@/components/inputs/CreatinineInput.vue';
import PathologyInput from '@/components/inputs/PathologyInput.vue';
import TargetInput from '@/components/inputs/TargetInput.vue';
import { useDosingStore } from '@/stores/dosing';

defineOptions({ name: 'HomeComponent' });

const store = useDosingStore();
const updatePatient = ref<string | null>(null);
const activeTab = ref(0);

const selectedDrug = computed(() => store.getDrug);
const selectedModel = computed(() => store.getModel);
const patientData = computed(() => store.getPatient);
const pathologyData = computed(() => store.getPathology);
const targetData = computed(() => store.getTarget);
const deliveryData = computed(() => store.getDelivery);

function update($evt: any, patientId: string) {
  updatePatient.value = patientId;
  store.saveSelectedId(patientId);
}

function switchTab($evt: any, tabId: number) {
  activeTab.value = tabId;
}
</script>

<style scoped>
.row {
  display: flex;
}
</style>
